var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.394 4c1.12 0 2.038.903 2.115 2.046l.006.158-.001.694h2.76c.4 0 .726.338.726.755 0 .382-.273.698-.628.748l-.098.007-.669-.001v9.39c0 1.163-.868 2.117-1.968 2.197l-.152.006h-6.97c-1.12 0-2.038-.903-2.115-2.046l-.006-.158V8.407h-.668c-.4 0-.726-.337-.726-.754 0-.382.273-.698.628-.748l.098-.007h2.759v-.694c0-1.164.869-2.118 1.97-2.198l.15-.006h2.79zm2.759 4.407H7.846v9.39c0 .35.252.641.578.687l.09.007h6.971c.339 0 .618-.262.662-.6l.007-.095-.001-9.389zm-5.547 2.114c.367 0 .671.284.72.652l.006.102v4.348c0 .416-.325.754-.726.754-.368 0-.672-.284-.72-.652l-.006-.102v-4.348c0-.416.325-.754.726-.754zm2.788 0c.368 0 .672.284.72.652l.006.102v4.348c0 .416-.325.754-.726.754-.367 0-.671-.284-.72-.652l-.006-.102v-4.348c0-.416.325-.754.726-.754zm0-5.012h-2.788c-.338 0-.618.262-.662.6l-.006.095-.001.694h4.125v-.694c0-.352-.251-.642-.577-.688l-.09-.007z",
    transform: "translate(-1197 -366) translate(385 177) translate(1 115) translate(804 67) translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.6998afb029e69639b7abc5704804d2aa.svg";
export { ForwardRef as ReactComponent };